import React, { useCallback, useState } from 'react';
import { Col, Modal, Row } from 'antd';
import { ProfileDropdown } from '../components/profileDropdown/ProfileDropdown/ProfileDropdown';
import { HeaderSearch } from '../components/HeaderSearch/HeaderSearch';
import { SettingsDropdown } from '../components/settingsDropdown/SettingsDropdown';
import { HeaderFullscreen } from '../components/HeaderFullscreen/HeaderFullscreen';
import * as S from '../Header.styles';
import { useTranslation } from 'react-i18next';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { Select } from '@app/components/common/selects/Select/Select';
import { Button } from '@app/components/common/buttons/Button/Button';
import { useNavigate } from 'react-router-dom';
import hitachi_logo_inspire from 'assets/logo_white.jpg';

interface DesktopHeaderProps {
  isTwoColumnsLayout: boolean;
}

const listShift = [
  {
    label: 'Issue',
    value: 'Issue',
  },
  {
    label: 'Task',
    value: 'Task',
  },
  {
    label: 'CheckList',
    value: 'CheckList',
  },
];

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ isTwoColumnsLayout }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const buttonCreateItem = () => {
    const module = window.location.pathname.split('/')[1];
    if (module === 'calib') return null;
    const onClick = module === 'fac'
      ? () => setIsOpenModal(true)
      : module === 'kaizen'
        ? () => navigate('/kaizen/actions/create-new')
        : () => navigate(module + '/issue/info');
    return <S.GHButton onClick={onClick} />;
  };

  const onOk = useCallback((values) => {
    switch (values.selectItem) {
      case 'Issue':
        navigate('/fac/issue/info');
        setIsOpenModal(false);
        break;

      case 'Task':
        navigate('/fac/task/info');
        setIsOpenModal(false);
        break;

      case 'CheckList':
        navigate('/fac/check-list/info');
        setIsOpenModal(false);
        break;

      default:
        navigate('/fac/issue/info');
        setIsOpenModal(false);
        break;
    }
  }, []);

  const leftSide = isTwoColumnsLayout ? (
    <S.SearchColumn xl={12} xxl={12}>
      <Row justify="space-between">
        <Col>{buttonCreateItem()}</Col>
        {/* <Col xl={15} xxl={12}>
          <HeaderSearch />
        </Col> */}
      </Row>
    </S.SearchColumn>
  ) : (
    <>
      <Col>{buttonCreateItem()}</Col>
      {/* <Col lg={10} xxl={8}>
        <HeaderSearch />
      </Col> */}
    </>
  );

  return (
    <Row justify="space-between" align="middle">
      {leftSide}
      {window.location.pathname.split('/')[1] === 'fac' ? (
        <Modal
          title={t('fac.header.createItem')}
          centered
          open={isOpenModal}
          onCancel={() => setIsOpenModal(false)}
          footer={[]}
        >
          <BaseButtonsForm name="addItem" requiredMark={true} onFinish={onOk} isFieldsChanged={false}>
            <Row gutter={{ md: 15, xl: 30 }}>
              <Col xs={24} md={12} xl={24}>
                <BaseButtonsForm.Item name="selectItem">
                  <Select key="selectItem" style={{ marginBottom: 18 }} options={listShift} defaultValue={'Issue'} />
                </BaseButtonsForm.Item>
              </Col>
            </Row>
            <Row style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
              <Button type="primary" htmlType="submit">
                {t('fac.common.confirm')}
              </Button>
            </Row>
          </BaseButtonsForm>
        </Modal>
      ) : null}

      <S.ProfileColumn xl={12} xxl={12} $isTwoColumnsLayout={isTwoColumnsLayout}>
        <Row align="middle" justify="end" gutter={[10, 10]}>
          <Col>
            <Row gutter={[{ xxl: 10 }, { xxl: 10 }]}>
              <Col>
                <HeaderFullscreen />
              </Col>

              {/* <Col>
                <NotificationsDropdown />
              </Col> */}

              <Col>
                <SettingsDropdown />
              </Col>
            </Row>
          </Col>

          <Col>
            <ProfileDropdown />
          </Col>
          <Col style={{ marginLeft: 10 }}>
            <img src={hitachi_logo_inspire} alt="Hitachi" height={40} />
          </Col>
        </Row>
      </S.ProfileColumn>
    </Row>
  );
};
